package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateProductIngredient(
    @SerialName("amount")
    val amount: Double?,
    @SerialName("contains")
    val contains: Boolean?,
    @SerialName("id")
    val id: String?,
    @SerialName("ingredient")
    val ingredient: Ingredient?,
    @SerialName("ingredientId")
    val ingredientId: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("productId")
    val productId: String?,
    @SerialName("__typename")
    val typename: String?
)